import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Outlet } from '@remix-run/react';

import { OnboardingLayout } from '@shieldpay/bumblebee/layouts/onboarding';

import { ShieldpayLogo } from '@shieldpay/utilities-ui/shieldpay-logo';

export const Layout = () => {
  const [date] = useState<number>(() => Date.now());

  return (
    <OnboardingLayout
      header={<ShieldpayLogo />}
      footer={
        <FormattedMessage
          id="onboarding-payee.footer"
          values={{
            year: (
              <FormattedDate
                value={date}
                year="numeric"
                // react-19 react-intl issue requiring a key prop?
                key="year"
              />
            ),
          }}
        />
      }
    >
      <Outlet />
    </OnboardingLayout>
  );
};

export default Layout;
